interface DashboardCardProps {
  title: string;
  value: number;
  icon: React.ReactNode;
  accentClass: string;
  iconBgClass: string;
}

export function DashboardCard({
  title,
  value,
  icon,
  accentClass,
  iconBgClass,
}: DashboardCardProps) {
  return (
    <div
      className={`group relative overflow-hidden rounded-2xl border border-gray-100 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md ${accentClass}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 flex-1 flex-col gap-3">
          <span className="text-sm font-medium text-gray-500">{title}</span>
          <span className="text-3xl font-bold tracking-tight text-gray-900">
            {value.toLocaleString("fa-IR")}
          </span>
        </div>
        <div
          className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${iconBgClass}`}
        >
          {icon}
        </div>
      </div>
    </div>
  );
}
